module.exports = __webpack_public_path__ + "media/images/icons8-school-locker-90aacbbab7719ecc54e7ea246a8e863a.svg";